<template>
  <v-card class="pa-4">
    <v-card-title class="d-flex align-center mt-2 mb-2">
      <v-icon class="mr-2" color="success">mdi-check-circle</v-icon>
      <h3 class="mb-0">
        <strong>Pedido Completado</strong>
      </h3>
    </v-card-title>
    <v-card-text>
      <v-card
        variant="tonal"
        color="success"
        class="mb-4 text-center"
      >
        <v-card-text class="py-6">
          <v-icon 
            color="success" 
            size="64"
            class="mb-4"
          >
            mdi-check-circle
          </v-icon>
          <h4 class="font-weight-medium text-success-darken-1 mb-4">
            <strong>¡Pedido Empaquetado!</strong>
          </h4>
          <div class="space-y-1">
            <h5 class="text-success-darken-1">
              Pedido ML: {{ selectedOrder?.code }}
            </h5>
            <h5 class="text-success-darken-1">
              Cliente: {{ selectedOrder?.client.name }}
            </h5>
            <h5 class="text-success-darken-1">
              Items: {{ totalValidated }}
            </h5>
            <h5 class="text-success-darken-1">
              Bultos: {{ packages.length }}
            </h5>
            <h5 class="text-success-darken-1">
              Etiquetas impresas: {{ packages.length }}
            </h5>
          </div>
        </v-card-text>
      </v-card>

      <v-row dense>
   
        <v-col cols="12" md="6">
          <v-btn
            ref="newLPNButton"
            variant="outlined"
            color="#2e3d45"
            @click="handleNewLPN"
            @keydown.enter="handleNewLPN"
            block
            size="large"
          >
            <v-icon start>mdi-rotate-left</v-icon>
            Escanear Nuevo LPN
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
            ref="nextOrderButton"
            :disabled="pendingCount === 0"
            color="primary"
            @click="handleNextOrder"
            @keydown.enter="handleNextOrder"
            block
            size="large"
          >
            <v-icon start>mdi-arrow-right</v-icon>
            Siguiente Pedido ({{ pendingCount }} pendientes)
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OrderComplete',
  props: {
    selectedOrder: {
      type: Object,
      default: null
    },
    packages: {
      type: Array,
      default: () => []
    },
    pendingCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['next-order', 'new-lpn'],
  computed: {
    totalValidated() {
      return this.selectedOrder?.items.reduce((acc, item) => acc + item.validated, 0) || 0
    }
  },
  methods: {
    handleNextOrder() {
      this.$emit('next-order')
    },
    handleNewLPN() {
      this.$emit('new-lpn')
    }
  }
}
</script>

<style scoped>
.space-y-1 > * + * {
  margin-top: 4px;
}
</style>